import type { IExtendedDexfSettings } from './dexfSettingsTypes';

const defaultState: IExtendedDexfSettings | {} = {};
export default defaultState;
